"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.voice-agent.disabled': 'Funkcja agenta głosowego nie jest dostępna w Twoim obecnym planie.',
};
